function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "mitreattack");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Visual-screens-April-May-June-21",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-158.000000, -49.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "scan",
  transform: "translate(158.000000, 49.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.000000, 4.000000)",
  fill: "#18C7B6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.6,4 L0,4 L0,0 L4,0 L4,1.6 L1.6,1.6 L1.6,4 Z M16,4 L14.4,4 L14.4,1.6 L12,1.6 L12,0 L16,0 L16,4 Z M0.8,8.8 L15.2,8.8 L15.2,7.2 L0.8,7.2 L0.8,8.8 Z M4,16 L0,16 L0,12 L1.6,12 L1.6,14.4 L4,14.4 L4,16 Z M16,16 L12,16 L12,14.4 L14.4,14.4 L14.4,12 L16,12 L16,16 Z",
  id: "Shape"
})))));

var SvgMitreattack = function SvgMitreattack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMitreattack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mitreattack.73a234bc.svg";
export { ForwardRef as ReactComponent };